import css from "classnames";
import * as React from "react";
import { SportEvent } from "./model";

import TimeComponent from "../../TimeComponent";
import TimeCounter from "../../TimeCounter";

const styles = require("./styles.scss"); // tslint:disable-line no-var-requires

interface Props {
    sportEvent: SportEvent;
}

class SoccerPreLive extends React.Component<Props> {
    public render(): JSX.Element | null {
        if (!this.props.sportEvent) {
            return null;
        }

        const { event } = this.props.sportEvent;

        return (
            <div className={styles.scorecenter}>
                <section className={styles.soccer}>
                    <div className={css(styles.row, styles.bottom)}>
                        <div className={css(styles.team)}>{event.team1}</div>
                        {this.renderTimeComponent(this.props.sportEvent)}
                        <div className={css(styles.team, styles.right)}>
                            {event.team2}
                        </div>
                    </div>
                </section>
            </div>
        );
    }

    public renderTimeComponent(sportEvent: SportEvent): JSX.Element {
        if (sportEvent.countdownInMillis) {
            return <TimeCounter countDown={sportEvent.countdownInMillis} />;
        } else {
            return <TimeComponent datetime={sportEvent.event.dateAndTime} />;
        }
    }
}

export default SoccerPreLive;
